module.exports = __webpack_public_path__ + "media/flags/009-australia-1d73689c.svg";